import React from "react";
import ProjectTemplate from "../components/ProjectTemplate";

const OtbbPage = () => {
  const media = [
    '/images/otbb_1.webp', 
    '/images/otbb_2.webp', 
    '/images/otbb_3.webp' 
    ];

  return (
    <div className="otbb-page">
      <ProjectTemplate
        title="O.T.B.B (Ode To Ben Burt)"
        year="2018"
        sections={[
          {
            type: "description",
            text: 'Ode to Ben Burtt is an audio-visual composition inspired by science-fiction foley and sound design. The sound solely consists of linear envelopes on granular synthesis, giving the work a specific special-effect-like timbre. Part of what characterizes this timbre is how certain parameters are created in generative way; likewise a similar approach also applies to the way the visuals are produced.',
          },
          {
            type: "video",
            links: [
                
              "https://www.youtube.com/embed/H3W5o_Zn6eY?si=stq4kyLrKzmfsJ_Q?controls=1&modestbranding=1&showinfo=0",
            ],
          },
          {
            type: "image",
            links: [
              {
                src: media[0]
              }
            ],
            isLink: false,
          },
          {
            type: "image", 
            links: [
              {
                src: media[1]
              }
            ], 
            isLink: false, 
          }, 
          {
            type: "image", 
            links: [
              {
                src: media[2]
              }
            ], 
            isLink: false, 
          }
        ]}
      />
    </div>
  );
};

export default OtbbPage;
